import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from '../../../../utils'

export const createSubscriptionRoutesMap = (prefix: string) => ({
  '/:id': (id: string) =>
    pathJoin(prefix)('id')(id).chainWithTitle({
      title: <T _str="Subscription Details" />,
      breadCrumbTitle: <T _str="Subscription Details" />,
    }),
})
